import classNames from 'classnames';
import { FC, ReactNode } from 'react';

type PropTypes = {
  active?: boolean;
  title?: ReactNode;
  Icon?: ReactNode;
  subtitle?: string;
  onClick?: () => void;
};

const InfoCard: FC<PropTypes> = ({
  Icon,
  subtitle,
  title,
  active,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={classNames('card-info', {
        'card-info__active': active,
        'card-info__pointer': !!onClick,
      })}
    >
      <div className="card-info__headline">
        <p className="card-info__title">{title}</p>

        {!!Icon && <span className="card-info__icon">{Icon}</span>}
      </div>

      <p className="card-info__subtitle">{subtitle}</p>
    </div>
  );
};

export default InfoCard;
